export enum PrivacyPolicyStatus {
  NOTAVAILABLE = 'NOTAVAILABLE',
  ACKNOWLEDGED = 'ACKNOWLEDGED',
  REJECTED = 'REJECTED',
  EXPIRE_OUTDATED = 'EXPIRE OUTDATED',
  EXPIRE_VERSION_UPDATED = 'EXPIRE VERSION UPDATED',
}
